module.exports = __webpack_public_path__ + "static/media/sneakpeak-01.c15e1253.jpg";